/* unplugin-vue-components disabled */import script from "./account_auth.vue?vue&type=script&setup=true&lang=js"
export * from "./account_auth.vue?vue&type=script&setup=true&lang=js"

import "./account_auth.vue?vue&type=style&index=0&id=ef5c65f6&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef5c65f6"]])

export default __exports__